<template>
    <div class="modal-overflow">
      <p><i class="nc-icon nc-alert-circle-i" style="margin-right: 5px" /><span v-html="data.message"></span></p>
      <p-checkbox v-if="data.showButton" v-model="confirm">I understand this is final and cannot be undone.</p-checkbox>
      <div class="col-md-12 text-center" v-if="data.showButton">
        <button :disabled="!confirm" @click="deleteEntity" class="btn btn-fill btn-info btn-wd btn-danger">Delete</button>
      </div>
      <div class="col-md-12 text-center" v-else>
        <button @click="() => this.$emit('close')" class="btn btn-fill btn-info btn-wd">Close</button>
      </div>
    </div>
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        confirm: false
      }
    },
    methods: {
      async deleteEntity() {
        this.confirm = false
        await this.data.delete()
        this.$emit('close')
        this.confirm = true
      }
    }
  }
</script>
